// extracted by mini-css-extract-plugin
module.exports = {"details":"OrderStatusDetails_details__3tBDR","iconUploader":"OrderStatusDetails_iconUploader__WWtfG"};